function getQueryParam(param) 
{
    var result =  window.location.search.match(
        new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)")
    );

    return result ? result[3] : false;
}

function handleThankYouMessage( )
{
    var URL = window.location.search;

    // var requestType = URL.split( "=" )[ 1 ];
    var requestType = getQueryParam("type");

    // use this zip code to map and display the Nearest Showroom
    var zip_code = getQueryParam("Postcode");
    // console.log("zip_code:::: ",zip_code);

    var messages = document.querySelectorAll( ".thank-you-item" );


    for( var i = 0; i < messages.length; i++ )
    {
        var message = messages[ i ];

         console.log(message.dataset.requestType,'===', requestType)
        if( message.dataset.requestType == requestType )
        {
            message.classList.remove( "hidden" );
        }
    }
}

function goBackToPreviousPage( )
{
    var parent = document.querySelector( ".bridgman-thank_you-container" );
    var timeoutTime = parseInt( parent.dataset.redirectTime )
    if( timeoutTime > 1000 )
    {
        setTimeout( function( ) {
            history.back();
        }, timeoutTime)
    }
}

window.addEventListener( "load", function( )
{
    handleThankYouMessage();
  	
  	if( window.parent && window.parent.location && window.parent.location.pathname.includes( "/admin/themes/" ) )
    {
      
    }
    else
    {
         goBackToPreviousPage(); 
    }
})